import React from 'react';

import { LinkPAStyle, StyledLink, StyledLinkUnderline } from '../components/ui';

type Props = {
  a: (chunk: string) => JSX.Element;
};

type Options = {
  href: string;
  onClick?: OnClickHrefTo;
  dataTestId?: string;
};

type OnClickHrefTo = (link: string) => void;

export const hrefTo = ({ href, onClick, dataTestId }: Options): Props => ({
  a: (chunk: string) => (
    <LinkPAStyle
      data-test-id={dataTestId || 'link-external'}
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={() => (onClick ? onClick(href) : null)}>
      {chunk}
    </LinkPAStyle>
  )
});

export const linkTo = ({ href, onClick, dataTestId }: Options): Props => ({
  a: (chunk: string) => (
    <StyledLink
      to={href}
      onClick={() => (onClick ? onClick(href) : null)}
      data-test-id={dataTestId || 'link-external'}>
      {chunk}
    </StyledLink>
  )
});

export const linkToUnderline = ({ href, onClick, dataTestId }: Options): Props => ({
  a: (chunk: string) => (
    <StyledLinkUnderline
      to={href}
      onClick={() => (onClick ? onClick(href) : null)}
      data-test-id={dataTestId || 'link-external'}>
      {chunk}
    </StyledLinkUnderline>
  )
});
